import {
  CompanyContainer,
  CompanyContentContainer,
  CompanyTabsContent,
  CompanyTabsList,
} from "components/company/v3/CompanyContainers";
import useBrazilianHighlights from "components/company/v3/brazilian/boxes/hooks/useBrazilianHighlights";
import BrazilianHighlightsContent from "components/company/v3/brazilian/contents/highlights/BrazilianHighlightsContent";
import BrazilianVideosContent from "components/company/v3/brazilian/contents/highlights/BrazilianVideosContent";
import { CompanyHighlightsTabEnum } from "components/company/v3/menu/enums";
import { Tabs } from "components/ui/Tabs";
import useSelfie from "lib/hooks/useSelfie";
import notUndefinedOrNull from "lib/utils/notUndefinedOrNull";
import { ListChecksIcon, YoutubeIcon } from "lucide-react";
import { useIntl } from "react-intl";

interface BrazilianHighlightsBoxProps {
  tab: CompanyHighlightsTabEnum;
  onChangeTab: (tab: CompanyHighlightsTabEnum) => void;
}

export default function BrazilianHighlightsBox({ tab, onChangeTab }: BrazilianHighlightsBoxProps) {
  const intl = useIntl();
  const viewer = useSelfie();
  const { highlights, setFilterByFinancialHighlightsId } = useBrazilianHighlights();

  return (
    <CompanyContainer className="xl:h-full">
      <CompanyContentContainer>
        <Tabs
          defaultValue={CompanyHighlightsTabEnum.VIDEOS}
          value={tab}
          onValueChange={(value) => onChangeTab(value as CompanyHighlightsTabEnum)}
          className="h-full w-full"
        >
          <CompanyTabsList
            activeTab={tab}
            tabs={[
              {
                value: CompanyHighlightsTabEnum.VIDEOS,
                label: intl.formatMessage({
                  defaultMessage: "Vídeos",
                  description: "Aba do menu superior da empresa",
                  id: "euAF41",
                }),
                icon: <YoutubeIcon className="inline-flex" size={16} strokeWidth={2} />,
              },
              viewer?.isPremium
                ? {
                    value: CompanyHighlightsTabEnum.HIGHLIGHTS,
                    label: intl.formatMessage({
                      defaultMessage: "Destaques Trimestrais",
                      description: "Aba do menu superior da empresa",
                      id: "od7EqT",
                    }),
                    icon: <ListChecksIcon className="inline-flex" size={16} strokeWidth={2} />,
                  }
                : null,
            ].filter(notUndefinedOrNull)}
          />

          <CompanyTabsContent value={CompanyHighlightsTabEnum.VIDEOS}>
            <BrazilianVideosContent />
          </CompanyTabsContent>

          {viewer?.isPremium && (
            <CompanyTabsContent value={CompanyHighlightsTabEnum.HIGHLIGHTS}>
              <BrazilianHighlightsContent
                highlights={highlights}
                setFilterByFinancialHighlightsId={setFilterByFinancialHighlightsId}
              />
            </CompanyTabsContent>
          )}
        </Tabs>
      </CompanyContentContainer>
    </CompanyContainer>
  );
}
